export enum ProgressBarVariants {
  DEFAULT = 'default',
  NAVIGATION = 'navigation',
  STEPPER = 'stepper',
}

type ProgressBarDefault = {
  variant: ProgressBarVariants.DEFAULT;
  totalSteps: number;
};

type ProgressBarDefaultNav = {
  variant: ProgressBarVariants.NAVIGATION;
  title: string;
  totalSteps: number;
};

type ProgressBarStepper = {
  variant: ProgressBarVariants.STEPPER;
  title: string;
  totalSteps: number;
  progressBarName: 'profile' | 'personality' | 'relationship';
  totalProfileSteps: number;
  totalPersonalitySteps: number;
  totalRelationshipSteps: number;
};

export type ProgressBar = ProgressBarDefault | ProgressBarDefaultNav | ProgressBarStepper;
